import React, { useEffect, useState } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function CustomerFeedback() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const res = await fetch(AIRTABLE_URL, {
          headers: AIRTABLE_HEADERS
        });

        const json = await res.json();

        const records = json.records.map(record => ({
          id: record.id,
          ...record.fields
        }));

        const filteredData = records.filter(
          item =>
            item.feedback &&
            item.feedback.trim() !== "" &&
            item.rating &&
            /\d/.test(item.rating)
        );

        setFeedbacks(filteredData);
      } catch (err) {
        console.error("Error fetching feedbacks", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedbacks();
  }, []);
  
  // ⭐ Star-wise count
  const starCounts = [1, 2, 3, 4, 5].reduce((acc, star) => {
    acc[star] = feedbacks.filter(
      (item) => parseInt(item.rating) === star
    ).length;
    return acc;
  }, {});

  // 🔢 Average rating
  const totalRatings = feedbacks.reduce(
    (sum, item) => sum + (parseInt(item.rating) || 0),
    0
  );
  const averageRating =
    feedbacks.length > 0 ? (totalRatings / feedbacks.length).toFixed(1) : 0;

  const visibleFeedbacks = showAll ? feedbacks : feedbacks.slice(0, 3);

  const maxCount = Math.max(...Object.values(starCounts), 1); // avoid divide by zero

  return (
    <div
      style={{
        padding: "50px 20px",
        textAlign: "left",
        position: "relative",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      {/* ❌ Close Button */}
      <button
        onClick={() => (window.location.href = "/")}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "none",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
          color: "Black",
        }}
      >
        ✖
      </button>

      <h2 style={{ marginTop: 0 }}>📝 Customer Feedback</h2>

      {/* ⭐ Ratings Summary */}
      {!loading && feedbacks.length > 0 && (
        <div
          style={{
            marginBottom: 10,
            padding: 15,
            backgroundColor: "#e6f0ff",
            border: "1px solid #ccc",
            borderRadius: 8,
          }}
        >
          <h3>⭐ Ratings Summary</h3>
          {[5, 4, 3, 2, 1].map((star) => {
            const count = starCounts[star] || 0;
            const widthPercent = (count / maxCount) * 100;
            return (
              <div key={star} style={{ marginBottom: 8 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ width: 60 }}>{star} Star</span>
                  <div
                    style={{
                      backgroundColor: "#ffd700",
                      height: 12,
                      width: `${widthPercent}%`,
                      borderRadius: 4,
                      margin: "0 10px",
                      minWidth: 10,
                      transition: "width 0.3s",
                    }}
                  />
                  <span>{count}</span>
                </div>
              </div>
            );
          })}

          {/* 🔢 Average & Total Reviews */}
          <div style={{ marginTop: 10 }}>
            <p><strong>⭐ Average Rating:</strong> {averageRating} / 5</p>
            <p><strong>🧾 Total Reviews:</strong> {feedbacks.length}</p>
          </div>

          {/* 👇 View All Button - moved here */}
          {!loading && feedbacks.length > 3 && (
            <div style={{ textAlign: "center", marginTop: 15 }}>
              <button
                onClick={() => setShowAll(!showAll)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                {showAll ? "Hide Reviews" : "View All Reviews and Ratings"}
              </button>
            </div>
          )}
        </div>
      )}

      {/* 💬 Feedback Cards */}
      {loading ? (
        <p>Loading feedbacks...</p>
      ) : feedbacks.length === 0 ? (
        <p>No feedbacks available.</p>
      ) : (
        visibleFeedbacks.map((item, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: "10px 10px",
              marginBottom: 5,
              backgroundColor: "#f9f9f9",
              maxWidth: "100%",
            }}
          >
            <p><strong> Name:</strong> {item.name || "N/A"}</p>
            <p><strong> Pin Code:</strong> {item.pincode || "N/A"}</p>
            <p><strong> Service:</strong> {item.services || "N/A"}</p>
            <p><strong>⭐ Rating:</strong> {item.rating}</p>
            <p><strong>💬 Feedback:</strong> {item.feedback}</p>
          </div>
        ))
      )}
    </div>
  );
}
